/* template */
<template><div class="mpx-root-view"><es-layout custom-class="custom-class" custom-main="custom-main" :layout="(['header'])" :esMainStyle="(esMainStyle)" navbarTitle="" navbarStyle="" :useDefaultNavbar="(false)" :useBlankPage="(useBlankPage)" :blankImageUrl="(blankImageUrl)" :blankContextTitle="(blankContextTitle)" :blankContextSubTitle="(blankContextSubTitle)" :hasBlankButton="(hasButton)" blankPageType="blank-page" @blank-retry="getTrainDetailFunc"><div slot="header" :style="[({background: '#fff'})] | transRpxStyle"><es-navbar :style="[(navbarStyle)] | transRpxStyle" :left-arrow="(true)" @click-left="goBackReport" class="headerStyle"><div class="es-navbar-title" v-if="(!fromChangeTicket)"><date-card ref="__mpx_ref_date_card__" :value="(time)" :date-type="('MM-dd')" checkType="single" :linking="(linking)" :isUpdateEveryTime="(true)" :checkRange="(7)" dateType="M月d日" :maxDate="(maxDateTime)" :minDate="(minDateTime)" :maxHeaderDate="(headerMaxDateTime)" :minHeaderDate="(headerMinDateTime)" startText="去程" endText="返程" title="选择前往日期" :closeable="(true)" :disable="(isTransfer || !showTrainInfomation)" @confirm="onConfirm" @handleClickDay="handleClickDay" @reportClick="dateCardClickReport"/></div><change-navbar :process="(1)" v-else/><div slot="right" v-if="(!fromChangeTicket)"><mpx-view @tap="jumpFn" class="es-navbar-right">购票须知</mpx-view></div></es-navbar></div><div :style="[({background: '#fff'})] | transRpxStyle" class="train-info"><train-information-new noDetail :trainInfo="(trainInfo)" @click="showSSI" v-if="(!isTransfer)"/><div v-for="(item, index) in (trainInfo.transfer_ticket)" v-else><train-information-new noDetail isTransfer :cardIndex="(index + 1)" :trainInfo="(item)" @click="showSSI"/><transfer-info-tip :style='["margin: 0 -10px"] | transRpxStyle' :startStation="(item?.to_station_name ?? '')" :toStation="(trainInfo?.transfer_ticket[index + 1]?.from_station_name ?? '')" :stopTime="(trainInfo.transfer_stop_time)" v-if="(index !== trainInfo.transfer_ticket?.length - 1)"/></div></div><div class="train-detail-container" v-if="(showTrainInfomation)"><guide-tips pageType="detail" :trainInfo="(trainInfo)" v-if="(isPreScramble)"/><div><seat-information v-for="(item, index) in (selectSeatInfo)" :class="(selectSeatInfo.length > 1 && 'seat-information')" :isStudent="(isStudent)" :fromChangeTicket="(fromChangeTicket)" :isPreScramble="(isPreScramble)" :selectSeatInfo="(item)" :ticketData="(ticketData[index])" :seatInfoIndex="(index)" @reportClick="seatInfoClickReport" @show="openPriceEstimation"/></div><buy-ticket-card :from="(from)" :buttonType="(cardType)" :privacyList="(privacyList)" :trackParams="(trackParams)" @reportClick="buyClickReport" @resetPrivacyList="resetPrivacyList"/><div class="split-line" v-if="(showExemption)"></div><buy-ticket-card :buttonType="(1)" :from="(from)" :privacyList="(privacyList)" :trackParams="(trackParams)" @reportClick="buyClickReport" @getServiceDescription="getServiceDescription" @resetPrivacyList="resetPrivacyList" v-if="(showExemption)"/></div><div class="skeleton" v-else><div class="skeleton-item"><div v-for="(item, index) in (3)" class="skeleton-1"></div></div><div class="skeleton-bottom"><div class="skeleton-2"></div><div class="skeleton-3"></div><div class="skeleton-split-line"></div><div class="skeleton-4"></div><div class="skeleton-5"></div></div></div></es-layout><stay-info-drawer :show="(showStayInfo)" title="时刻表" :isTransfer="(isTransfer)" :stayInfo="(stayInfo)" :stayInfoList="(stayInfoList)" @close="closeSSI" @setStayInfo="setStayInfo"/><price-detail-info-alter :show="(showPriceEstimation)" :title="(priceEstimation.title)" :priceDetail="(priceEstimation.detail)" priceDetailCardTip="卧铺价格仅供参考，以实际出票结果收取费用" @close="closePriceEstimation" :customStyle="(lowerDrawer)"/><nologin-description :show="(showServiceDescription)" @close="closeServiceDescription"/><es-toast id="es-toast"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mf04e85e4"}'>
  @import '~@/mixins/stylus/color.styl'

  .custom-class
    // background-image url('https://dpubstatic.udache.com/static/dpubimg/4hnS2tq0TNoruy-zYTC4p.png')
    // background-repeat no-repeat
    // background-position center center
    // background-size cover
    background #f2f6f9
  .es-navbar-title
    font-size 18px
    font-weight 600
    color #000004
  .es-navbar-right
    font-size 14px
    font-weight 400
    color $train-color-333
  .train-info
    padding 0 10px 10px 
  .train-detail-container
    margin 10px
    background #fff
    border-radius 8px
    padding 14px 14px 4.25px 14px
    .split-line
      height 1px
      background #EEEEEE
  .skeleton
    margin 10px
    // width 355px
    height 256px
    background #FFFFFF
    border-radius 8px
    &-item 
      display flex
      padding 14px 0 14px 14px
    &-1
      display flex
      flex-direction row
      width 104px
      height 74px
      border-radius 10px
      background #E4EAEF
      margin-right 8px
    &-bottom
      width 355px
      height 84px
      // background pink
      position relative
    .skeleton-split-line
      position absolute 
      top 84px
      left 14px
      height 1px
      width 355px
      background #EEEEEE
    &-2
      position absolute 
      width 105px
      height 20px
      background #E4EAEF
      border-radius 6px
      top 34px
      left 14px
    &-3
      position absolute 
      width 40px
      height 40px
      background #FF6400
      border-radius 10px
      left 301px
      top 24px
    &-4
      position absolute 
      width 105px
      height 20px
      background #E4EAEF
      border-radius 6px
      left 14px
      top 114px
    &-5
      position absolute 
      width 40px
      height 40px
      background #FF6400
      border-radius 10px
      left 301px
      top 104px
  .seat-information
    &:not(:last-child)
      margin-bottom 10px
    &:last-child
      margin-bottom 5px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mf04e85e4"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["mf04e85e4"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-toast':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/toast/index.mpx?isComponent&outputPath=components%2Findex68e47551%2Findex")),'guide-tips':getComponent(require("../search/components/guide-tips.mpx?isComponent&outputPath=components%2Fguide-tips99b597a0%2Findex")),'stay-info-drawer':getComponent(require("../../components/stay-info-drawer.mpx?isComponent&outputPath=components%2Fstay-info-drawer20921e4e%2Findex")),'transfer-info-tip':getComponent(require("../../components/transfer-info-tip.mpx?isComponent&outputPath=components%2Ftransfer-info-tip794aa58f%2Findex")),'drawer-bottom':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/drawer-bottom/index.mpx?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex")),'seat-information':getComponent(require("./components/seat-information/index.mpx?isComponent&outputPath=components%2Findex17fa8b3c%2Findex")),'date-card':getComponent(require("./components/date-card/index.mpx?isComponent&outputPath=components%2Findex35be2d8b%2Findex")),'buy-ticket-card':getComponent(require("./components/buy-ticket-card/index.mpx?isComponent&outputPath=components%2Findex29d740e6%2Findex")),'nologin-description':getComponent(require("./components/nologin-description/index.mpx?isComponent&outputPath=components%2Findexf369d19a%2Findex")),'train-information-new':getComponent(require("../../components/train-information-new/index.mpx?isComponent&outputPath=components%2Findex7f4255a4%2Findex")),'change-navbar':getComponent(require("../../components/change-navbar/index.mpx?isComponent&outputPath=components%2Findex262f9081%2Findex")),'price-detail-info-alter':getComponent(require("../../components/price-detail-info-alter/index.mpx?isComponent&outputPath=components%2Findex853d8b3a%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
